import React, { useState } from 'react';
import {
  Button,
} from '@material-ui/core';

import Dialog from '../../ui/Dialog';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay.component';
import { putTransactionCodeFreeGoodApprove, updateFreeBoxStatusAndDetails } from '../../../services/transaction.service';

const FreeBoxDeliveredAtPharmacy = ({ data }) => {
    const { program_id, transaction_code_id } = data;

  const [state, setState] = useState({
    openConfirmation: false,
    openValidateConfirmation: true,
    modalTitle: 'Free Box Delivered At Pharmacy',
    errorMessage: null,
    successMessage: 'Free box has been delivered at pharmacy successfully!',
    isLoading: false,
    latestMessage: '',
    messageLogId: null,
    submitButtonEnabled: false,
  });

  const handleClose = () => {
    const { openConfirmation } = state;
    setState(prev => ({
      ...prev,
      openConfirmation: false,
      openValidateConfirmation: false,
      errorMessage: null
    }));

    if (openConfirmation) {
      window.location.reload();
    }
  };

  const onValidate = async () => {
    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const { message } = await updateFreeBoxStatusAndDetails({
        transaction_code_id,
        connect_program_id: program_id,
        payload: {
          action: 'free-box-at-pharmacy',
        },
      });
      
      setState(prev => ({
        ...prev,
        openValidateConfirmation: false,
        successMessage: message
      }));
    } catch (e) {
      setState(prev => ({
        ...prev,
        errorMessage: e.message
      }));
    } finally {
      setState(prev => ({ ...prev, isLoading: false, openValidateConfirmation: false, openConfirmation: true }));
    }
  };

  const {
    openConfirmation,
    modalTitle,
    errorMessage,
    successMessage,
    isLoading,
    openValidateConfirmation
  } = state;

  if (isLoading) return <LoadingOverlay />;

  const formButtons = (
    <>
      <Button onClick={handleClose} variant="contained">
        {openConfirmation ? 'OK' : 'Close'}
      </Button>
      {
        openValidateConfirmation && 
        <Button
          onClick={onValidate}
          variant="contained"
          color="primary"
          disabled={false}
        >
          Confirm
        </Button>
      }
    </>
  );

  return (
    <>
      <Dialog
        key="free-box-delivered-at-pharmacy"
        open={openValidateConfirmation}
        title={modalTitle}
        content = {`Are you sure to the delivery of the free box at pharmacy?`}
        children={formButtons}
        onSubmit={onValidate}
        onClose={handleClose}
      />
      <Dialog 
        onSubmit={handleClose}
        key="confirmation"
        open={openConfirmation}
        title='Free Box Delivered At Pharmacy'
        content={errorMessage || successMessage}
        children={formButtons}
        onClose={handleClose}
      />
      <Button variant="contained" color="primary" onClick={() => {
         setState(prev => ({
          ...prev,
          openValidateConfirmation: true,
        }));
      }} style={{ marginRight: 8 }}>
        Confirm
      </Button>
    </>
  );
};

export default FreeBoxDeliveredAtPharmacy;